import React from 'react';

import AppButton from '../../../designe/app-button/AppButton';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../../../shared/paths';
import { AvatarTypes } from '../../../designe/app-avatar/AppAvatar';
import AppEntityAvatar, {
  AvatarSize,
} from '../../../designe/app-entity-avatar/AppEntityAvatar';
import { useGetMyDetails } from '../../../../services/redux/api/usersApi';
import { useStyles } from './CommunityBigItem.styles';
import theme from '../../../../styles/theme';
import { ICommunity } from '../../../../types/interfaces/community';
import { IRelation } from '../../../../types/interfaces/relation';

interface ICommunityBigItem {
  community: ICommunity;
  subscriptionRelation: IRelation;
  onSubscribe: (id: string) => void;
  onUnsubscribe: (id: string) => void;
}

export default function CommunityBigItem(props: ICommunityBigItem) {
  const { community, subscriptionRelation, onSubscribe, onUnsubscribe } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: user } = useGetMyDetails();
  const isUserOwner = community.ownerId === user?.id;
  const { classes } = useStyles(theme);

  function clickOnUserHandler() {
    navigate(`${Paths.communities.root}/${community.id}`);
  }

  return (
    <div className={classes.communityWrapper} onClick={clickOnUserHandler}>
      <div className={classes.avatarWrapper}>
        <AppEntityAvatar
          entity={community}
          size={AvatarSize.l}
          type={AvatarTypes.round}
        />
      </div>
      <div className={classes.communityDetails}>
        <div className={classes.infoWrapper}>
          <div className={classes.infoName}>{community.title}</div>
          <div>{community.description}</div>
        </div>
        <div
          className={classes.controlWrapper}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}>
          {!isUserOwner && (
            <>
              {!subscriptionRelation && (
                <AppButton onClick={() => onSubscribe(community.id)}>
                  {t('communitiesList.subscribe')}
                </AppButton>
              )}
              {subscriptionRelation && (
                <AppButton
                  variant="outlined"
                  onClick={() => onUnsubscribe(community.id)}>
                  {t('communitiesList.unsubscribe')}
                </AppButton>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
